import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.function.name.js";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import { i18n, lang } from '@/boot/i18n';
import { makeScreen } from "./_utils";
export default {
  type: 'nps',
  requiresTransaction: false,

  /**
   * Determines if a NPS question should be added to the selection
   *
   * @param {Object} context
   *
   * @returns {Boolean} true if the question should be added to the selection, else false.
   */
  select: function () {
    var _select = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", true);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function select() {
      return _select.apply(this, arguments);
    }

    return select;
  }(),

  /**
   * Renders a NPS Screen
   *
   * @param {Object} context
   *
   * @returns {Object} Screen model
   */
  render: function () {
    var _render = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(context) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", makeScreen(context, [{
                id: context.section.name,
                type: 'fib-slider',
                required: context.section.required,
                label: '',
                props: {
                  labelLeft: i18n.t('questions.nps.notVeryLikely'),
                  labelRight: i18n.t('questions.nps.veryLikely')
                }
              }], {
                title: lang('questions_nps_title')
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function render(_x) {
      return _render.apply(this, arguments);
    }

    return render;
  }(),

  /**
   * Parse a question answer
   *
   * @param {Object} context context
   * @param {Object} context.submit context.section
   * @param {Object} context.question context.question
   * @param {Object} context.response context.response
   */
  parseAnswer: function parseAnswer(context) {
    var _context$response$0$v, _context$response$;

    return {
      // use ?? to determine when to use the fallback instead of || as 0 is a valid value for NPS.
      nps: (_context$response$0$v = (_context$response$ = context.response[0]) === null || _context$response$ === void 0 ? void 0 : _context$response$.value) !== null && _context$response$0$v !== void 0 ? _context$response$0$v : null,
      mutateSubmit: function mutateSubmit(submit) {
        submit.npsScore = this.nps;
      }
    };
  }
};